<template>
  <PForm
    ref="pForm"
    :heading="`${formState.edit ? 'Edit' : 'Add'} Brand`"
    :primary-cta="submitButton"
    @close="closeForm"
    @reset="resetForm"
    @submit.prevent="submitForm"
  >
    <div class="row q-col-gutter-xl">
      <div class="col-6">
        <PInput
          v-model.trim="formData.name"
          label="Brand Name"
          placeholder="Enter brand name"
          required
          @update:model-value="
            (v) => {
              formData.name = upperFirstFunc(v);
            }
          "
        />
      </div>
    </div>
  </PForm>
</template>

<script setup>
import brandFormModel from "src/modules/brand/models/brandForm";
import { upperFirstFunc } from "assets/scripts/utilities/helpers";

const { brand, formState } = storeToRefs(useBrandStore());
const { postBrand, putBrand, toggleBrandForm } = useBrandStore();

const pForm = ref(null);

const { formData, isLoading, closeForm, resetForm, submitForm } = useForm({
  formModel: brandFormModel(),
  entity: brand,
  formRef: pForm,
  isForm: formState,
  post: postBrand,
  put: putBrand,
  toggleForm: toggleBrandForm,
});

const submitButton = computed(() => {
  return {
    loading: unref(isLoading),
  };
});
</script>

<style lang="scss" scoped>
.q-slider {
  :deep(.q-field__inner):has(&) {
    .q-field {
      &__control,
      &__native {
        min-height: auto;
      }
    }
  }
}
</style>
